<template>
  <vx-card title="ویرایش پروفایل ">
    <div v-if="student">
      <avatar-uploader :image="student.imagePath" context="student" :user-id="student.id"></avatar-uploader>
      <form-student @lock="lockChanged" :data="student" @save="saveStudent"></form-student>
    </div>
  </vx-card>
</template>

<script>
  import {map, tileLayer} from 'leaflet';
  import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
  import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
  import FormStudent from "./FormStudent";
  import AvatarUploader from "../user/components/AvatarUploader";

  export default {
    name: "EditStudent",
    components: {AvatarUploader, FormStudent},
    data() {
      return {
        student: ''
      }
    },
    mounted() {
      this.$store.dispatch('getUser', {
        role: 'all',
        userId: Number(this.$route.params.id)
      }).then(user => {
        this.student = user
      })
      if (!this.$store.state.students.length)
        this.$store.dispatch('fetchStudents')

    },
    methods: {
      saveStudent(student) {
        this.$store.dispatch('editStudent', student)
          .then(() => {
            this.$router.push('/students')
          })
          .catch((err) => {
            console.log(err)
          })
      },
      lockChanged(user) {
        this.$store.commit('USER_LOCK_CHANGED', {
          role: 'student',
          userIds: [user.id],
          lock: Number(user.locked)
        })
      }
    }
  }
</script>

<style scoped>

  .vs-input {
    width: auto !important;
    padding: 0 5px;
  }

</style>
